import Vue from 'vue'

import NETVSIcon from '@/icons/NETVSIcon.vue'

Vue.component('netvs-icon', NETVSIcon)
